
(() => {
  const money = cents =>
    new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(cents / 100);

  function updateTotal() {
    document.querySelectorAll('[data-ds-total-price]').forEach(box => {
      const form = box.closest('form');
      if (!form) return;

      const quantity = form.querySelector('[name="quantity"]');
      const amount = Math.max(1, Number(quantity?.value) || 1);
      const unitPrice = Number(box.dataset.unitPrice);

      if (!Number.isFinite(unitPrice)) return;

      const price = box.querySelector('.price--highlight, .price:not(.price--compare)');
      if (!price) return;

      const total = money(unitPrice * amount);

      const textNodes = [...price.childNodes].filter(
        node => node.nodeType === Node.TEXT_NODE && node.textContent.trim()
      );

      if (textNodes.length) {
        textNodes[0].textContent = total;
      }
    });
  }

  document.addEventListener('change', event => {
    if (event.target.matches('[name="quantity"]')) {
      updateTotal();
    }
  });

  document.addEventListener('click', event => {
    if (event.target.closest('[data-action="increase-picker-quantity"], [data-action="decrease-picker-quantity"]')) {
      setTimeout(updateTotal, 0);
    }
  });

  document.addEventListener('DOMContentLoaded', updateTotal);
})();
